import { UseCase } from "../../useCase"
import { GetB2BContentResponse } from "./response"
import { GetB2BContentRequest } from "./request"
import { B2BRepository } from "../../../repositories/b2bRepository"

export class GetB2BContentUseCase implements UseCase<GetB2BContentRequest, GetB2BContentResponse> {
	private _repository

	constructor({ B2BRepository }: { B2BRepository: B2BRepository }) {
		this._repository = B2BRepository
	}

	exec() {
		return this._repository.getB2BContent()
	}
}
